import type { Locale } from "@/i18n/config";
import { localeToIntl } from "@/i18n/config";
import {
  formatCurrency as _formatCurrency,
  formatCurrencyWithCode as _formatCurrencyWithCode,
  formatNumber as _formatNumber,
  formatAmount as _formatAmount,
  formatCurrencyCompact as _formatCurrencyCompact,
} from "@donista/shared/utils/format-currency";

function getIntlLocale(locale?: Locale | string): string {
  if (!locale) return "de-DE";
  return localeToIntl[locale as Locale] ?? "de-DE";
}

export function formatCurrency(amount: number, currency: string = "EUR", locale?: Locale | string): string {
  return _formatCurrency(amount, currency, getIntlLocale(locale));
}

export function formatCurrencyWithCode(amount: number, currency: string = "EUR", locale?: Locale | string): string {
  return _formatCurrencyWithCode(amount, currency, getIntlLocale(locale));
}

export function formatNumber(value: number, locale?: Locale | string): string {
  return _formatNumber(value, getIntlLocale(locale));
}

export function formatAmount(amount: number, locale?: Locale | string): string {
  return _formatAmount(amount, getIntlLocale(locale));
}

export function formatCurrencyCompact(value: number, locale?: Locale | string): string {
  return _formatCurrencyCompact(value, getIntlLocale(locale));
}
